import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { fetchUser, login } from '../../../redux/actions/user-actions';
import s from './ProfileMenu.scss';
import { url } from '../../../config';
import { capitalize, abtest  } from '../../../utils';
import arrow_up from '../../../assets/images/icons/Arrow_up_2grey.svg';
import arrow_down from '../../../assets/images/icons/Arrow_down_2grey.svg';
import rightArrowGrey from '../../../assets/images/icons/Right-arrow-gray.svg';



class ProfileMenu extends React.Component {

    state = {
        collapse: false,
    }
    componentDidMount = () => {
       document.addEventListener('click', this.handleClick, false)
    }

    componentWillUnmount = () => {
        document.removeEventListener('click', this.handleClick, false)
    }

    handleCollapse = (e) => {
        e.preventDefault();
        this.setState({
            collapse: !this.state.collapse
        })
    }

    handleClick = (e) =>{
        if(!this.node.contains(e.target)){
            this.setState({
                collapse:false
            })
        }
    }

    getAvatar = (text) => {
        return text.split().map((str) => str ? str[0].toUpperCase() : "").join('')
    }

    getEmail = (mail) => {
        return mail.split('@')[0]
    }

    logoutUser = (e) => {
        e.preventDefault();
        axios.get('/api/v3/auth/logout/')
        .then(() => {
            window.location.href = "/";
        });
    }

    render() {
    const {collapse} = this.state;
    const {borrower, match, status, urlLocation, mobileMenu, abtestData} = this.props;

    let userName = borrower && borrower.first_name;
    let mail = borrower &&  borrower.email;
    let apptype = match && match.params.apptype;
    return (
        <div className={s.profileContainer} ref={node => this.node = node}>
            <div onClick={this.handleCollapse} className={s.profileBut}>
                <div className={s.profileIcon}>
                    <p className={s.profileAvatar}>{(userName) ? this.getAvatar(userName) : (mail && this.getAvatar(mail))}</p>
                </div>
                <p className={s.profileName} >{(userName) ? capitalize(userName) : ((mail) ? this.getEmail(mail) : '')}</p>
                 {!mobileMenu ? (collapse) ? <img className={s.arrowIcon} src={arrow_up} alt='flecha hacia arriba'/> : <img className={s.arrowIcon} src={arrow_down} alt='flecha hacia abajo'/> : ''}
            </div>
            <div  className={(collapse || mobileMenu) ? `${s.openElement} collapse` : s.collapseElement} id="collapseExample" >
                <div className={s.profileMenu}>
                    {/* <div  className = {s.profileTitle} > Mis Datos</div> */}
                    {status >= 30 &&
                        <div className={s.profileBody} >
                            <div className={s.creditContainer}>
                                <a href={url('mi-prestamo', apptype)} className={s.textCredit}>Editar mi solicitud</a><br/>
                                {mobileMenu &&
                                    <a className={s.faq} href={url('mi-prestamo', apptype)}>
                                        <img className={s.rightArrow} src={rightArrowGrey} alt='flecha derecha color gris'/>
                                    </a>
                                }
                            </div>
                            <div className={s.creditContainer}>
                                <a href={`${url('cambia-contrasena')}/?next=${window.location.pathname}`} className={s.textCredit}>Cambiar contraseña</a> <br />
                                {mobileMenu &&
                                    <a className={s.faq} href={`${url('cambia-contrasena')}/?next=${window.location.pathname}`}>
                                        <img className={s.rightArrow2} src={rightArrowGrey} alt='flecha derecha color gris'/>
                                    </a>
                                }
                            </div>
                            {(urlLocation && apptype != "ce") && <a href={urlLocation} target='_blank' className={s.text}>Cronograma de cuotas</a>}
                        </div>
                    }
                    <div className={s.logoutContainer}>
                        <a onClick={this.logoutUser}>Salir</a>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({});
const mapDispatchToProps = { fetchUser, login };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileMenu));
